<template>
  <step :context="context" image="/images/alarm-clock.svg" @back="$emit('back')" @submit="submit">
    <template #guideTitle>Son Adım!</template>
    <template #guideDescription>
      <div>
        <b>4. Sakin gün ve saatleri öne çıkaralım—</b>Belirli gün ve saatlerde üyelerinizi <b>2 kat parapuan veya mühür ile ödüllendirmeye</b> ne dersiniz?
        <div />
        <b>5. Pazarlama otomasyonu ile bir süredir gelmeyen müşterilerinizi geri kazanalım—</b>Kayıp üyelere indirim yaparak onları işletmenize gelmeye teşvik edebiliriz.
      </div>
    </template>
    <template #formTitle>Hediyeler ve Özel Promosyonlar</template>
    <template #form>
      <v-form v-model="valid" ref="form">
        <!-- Promote Days -->
        <form-section
          class="promote-section"
          header="4. Sakin Gün ve Saatler —  2 Kat Parapuan / Mühür"
          optional
        >
          <div class="inline">
            <!-- Days -->
            <v-checkbox
              v-for="day in ['Pazartesi','Salı','Çarş.','Perş.','Cuma','Cumartesi','Pazar']"
              :key="day"
              :label="day"
              v-model="model.promoteDaysAndTimes.days[day.toLowerCase()]"
            />
          </div>
          <!-- Times -->
          <v-radio-group
            :row="!mobile"
            class="times ma-0"
            hide-details
            v-model="model.promoteDaysAndTimes.times.value"
            :rules="rules.promoteDaysAndTimes.times"
          >
            <v-radio label="Tüm Gün" value="allDay" />
            <custom-radio
              label="Belli Saatlerde"
              value="specificHours"
              v-slot="{selected}"
              :indent="mobile"
            >
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.from"
                type="time"
                placeholder="5:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />-
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.to"
                type="time"
                class="ml-2"
                placeholder="8:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />
            </custom-radio>
            <div
              class="hint"
            >Öneri: Promosyon iletişimi için SMS göndermeyi öneriyoruz</div>
          </v-radio-group>
        </form-section>
        <!-- Win Back -->
        <form-section
          header="5. Pazarlama Otomasyonu — Müşterileri Geri Kazanma"
          optional
        >
          <div class="inline ma-0 pa-0">
            <v-select
              v-model="model.marketingAutomation.after"
              class="minimal"
              placeholder="60"
              :items="['Asla','30','60','90']"
            />
            <div> gündür gelmeyen üyelere </div>
            <v-text-field
                    v-model="model.marketingAutomation.activate"
                    class="minimal"
                    prefix="₺"
                    placeholder="5"
                    :rules="[rules.number]"
            />
            indirim gönderelim.
          </div>
        </form-section>
        <!-- Discount Alerts -->
        <form-section class="discount-section">
          <v-checkbox
            label="Bu indirimin iletişimi için SMS göndermek istiyorum."
            v-model="model.sendDiscountAlerts"
          />
          <div
            class="hint"
          >Paketinize aylık 500 SMS dahildir. Ek kullanım olması durumunda ayrıca ücretlendirilecektir.</div>
          <div class="terms mt-4">
            <span>
              Bu formu göndererek
              <a
                href="http://app4mobilebiz.wpengine.com/comosense-solution-general-terms.html"
                target="_blank"
              >Como - Bonobo'nun şartlar ve koşullarını</a> kabul ediyorum.
              <div>Sorularınızı yanıtlamak, taleplerinizi beraber değerlendirerek sadakat programının aktivasyonunu sağlamak ve eğitimi planlamak için bir müşteri temsilcimiz sizinle iletişime geçecektir.</div>
            </span>
          </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";
import displayMixin from "@/mixins/display";

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step,
    FormSection,
    CustomRadio
  },
  data() {
    const required = v => !!v || "Field is required";
    const times = {
      value: null,
      hours: {
        from: null,
        to: null
      }
    };
    return {
      valid: false,
      rules: {
        required,
        number: v => v == null || !isNaN(Number(v)) || "Value must be a number",
        promoteDaysAndTimes: {
          times: [
            v => {
              const daySelected = Object.keys(
                this.model.promoteDaysAndTimes.days
              )
                .map(day => this.model.promoteDaysAndTimes.days[day])
                .find(day => day === true);
              return !daySelected || v != null || "";
            }
          ],
          timeOption(selected) {
            if (!selected) return [];

            return [
              required,
              () => {
                const { to, from } = times.hours;
                if (to && from && from > to) {
                  return "Range must be valid";
                }
                return true;
              }
            ];
          }
        }
      },
      model: {
        promoteDaysAndTimes: {
          days: {
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false
          },
          times
        },
        marketingAutomation: {
          activate: null,
          after: null
        },
        sendDiscountAlerts: true,
        ...this.context.submittedData
      }
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    }
  }
};
</script>

<style lang="scss" scoped>
.promote-section {
  .times {
    top: -14px !important;
    position: relative;
    .hint {
      margin-top: 4px !important;
    }
    ::v-deep input {
      max-width: 100px;
    }
    #app.mobile & {
      top: 12px !important;
    }
  }
}
.discount-section {
  .hint {
    #app.mobile & {
      margin-top: 12px;
    }
  }
  .terms {
    span {
      font-size: 9px;
      font-weight: 600;
      font-style: italic;
      line-height: 2;
      letter-spacing: 0.25px;

      a {
        color: #007aff;
      }
    }

    .grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 60px;
      max-width: 400px;

      #app.mobile & {
        grid-template-columns: 1fr;
      }
    }
  }
}
</style>